import {handleSideMenu} from "../lib/common/sidebar";

$(window).resize(handleSideMenu);

$(window).on('load', handleSideMenu);
